import TextShadow from 'components/PhoneBoothScreen/animations/TextShadow';
import React, { useCallback, useState } from 'react';
import styled, { css, keyframes } from 'styled-components/macro';

const bgAnim = keyframes`
    0% {
        background-color: #0000009d;
    }
    25% {
        background-color: #00000080;
    }
    50% {
        background-color: #0000009d;
    }
    75% {
        background-color: #00000080;
    }
    100% {
        background-color: #0000009d;
    }

`;

const fadeout = keyframes`
    0% { opacity: 1; }
    100% { opacity: 0; }
`;

const StartingOverlayWrapper = styled.div<{ fadeOut: boolean }>`
  cursor: pointer;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: #000000be;
  position: fixed;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* animation: ${bgAnim} 15s infinite; */
  animation: ${({ fadeOut }) =>
    fadeOut &&
    css`
      ${fadeout} 1s linear forwards
    `};
  /* animation: ${({ fadeOut }) =>
    fadeOut
      ? css`
          ${fadeout} .8s linear forwards
        `
      : css`
          ${bgAnim} 15s infinite
        `}; */

  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: flex;
  `}
`;

const Label = styled.div`
  font-family: 'Presicav';
  animation: ${TextShadow} 1.6s infinite;
`;

const TapWrapper = styled.div`
  margin-top: 30px;
  position: relative;
  width: 50px;
  height: 50px;
  transform: scale(1.25);
`;

const circleFade = (maxOp: number) => keyframes`
    0%{
        opacity: 0;
    }
    50%{
        opacity: ${maxOp};
    }
    100%{
        opacity: 0;
    }
`;

const Circle = styled.div<{ scale: number; opacity: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: ${({ scale }) => scale * 50}px;
  height: ${({ scale }) => scale * 50}px;
  opacity: ${({ opacity }) => opacity};

  animation: ${({ opacity }) => circleFade(opacity)} 2s infinite;
  animation-delay: ${({ opacity }) => 1 - opacity}s;

  border-radius: 100%;
  border: 2px solid white;
`;
const TapText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 50px;
  height: 50px;

  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type StartingOverlayProps = {
  onStart: () => void;
};

const StartingOverlay: React.FC<StartingOverlayProps> = ({ onStart }) => {
  const [isFadingOut, setIsFadingOut] = useState(false);

  const fadeOutOverlay = useCallback(() => {
    setIsFadingOut(true);
    setTimeout(() => onStart(), 1000);
  }, [onStart]);

  return (
    <StartingOverlayWrapper fadeOut={isFadingOut} onClickCapture={() => fadeOutOverlay()}>
      <Label>Start Your Experience</Label>
      <TapWrapper>
        <Circle scale={1} opacity={0.2} />
        <Circle scale={0.85} opacity={0.4} />
        <Circle scale={0.7} opacity={0.75} />
        <TapText>Tap</TapText>
      </TapWrapper>
    </StartingOverlayWrapper>
  );
};

export default StartingOverlay;
